module.exports = __webpack_public_path__ + "static/media/todolist.0bf5c727.png";